/** SCBF magic bytes: ASCII "STAR" */
export const SCBF_MAGIC = new Uint8Array([0x53, 0x54, 0x41, 0x52]);

/** Current SCBF format version */
export const SCBF_VERSION = 1;

/** Size of the static header in bytes (magic + reserved + version + chunkCount) */
export const STATIC_HEADER_SIZE = 16;

/** Size of each chunk header in bytes (type + reserved + length) */
export const CHUNK_HEADER_SIZE = 8;

/** Chunk type identifier for the Document chunk (Y.js state update) */
export const CHUNK_TYPE_DOCUMENT = 0x01;

/** Chunk type identifier for a Header chunk (key-value metadata pair) */
export const CHUNK_TYPE_HEADER = 0x02;

/** Header key for the migration version at encoding time */
export const HEADER_MIGRATION_VERSION = 'migration_version';

/** Header key for the project UUID */
export const HEADER_PROJECT_ID = 'project_id';
